{
  "R": [0, 0, 0],
  "G": [0, 0, 0],
  "B": [0, 128, 255],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
